"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _broadcastCampaign = require('shared/validation/broadcastCampaign');

var _format = require('./format');

/* Rev 27 P3: the send pace is one of a few presets. The sender takes at most
 * 5 messages per 5-second run, so a second apart is as fast as it goes. */
 const PACE_PRESETS_MS = [_broadcastCampaign.MIN_MESSAGE_DELAY_MS, 5000, 10000, 30000]; exports.PACE_PRESETS_MS = PACE_PRESETS_MS

/* Exact, so a saved 4,500 ms reads 4.5 (review R800-37). */
const seconds = (ms) => +(ms / 1000).toFixed(3)

/* "As fast as possible" / "One every 10 seconds" */
 const paceLabel = (ms) =>
  ms <= _broadcastCampaign.MIN_MESSAGE_DELAY_MS ? 'As fast as possible' : `One every ${seconds(ms)} seconds`; exports.paceLabel = paceLabel

/* The presets, plus a saved value that isn't one, so nothing changes unasked. */
 const paceOptions = (savedMs) =>
  [...new Set([...exports.PACE_PRESETS_MS, savedMs])]
    .sort((a, b) => a - b)
    .map(ms => ({ value: String(ms), label: exports.paceLabel.call(void 0, ms) })); exports.paceOptions = paceOptions

/* How long count messages take, at least a second each: "5 minutes",
 * "3 hours", or null for under a minute. */
 const durationText = (count, delayMs) => {
  const ms = count * Math.max(delayMs, _broadcastCampaign.MIN_MESSAGE_DELAY_MS)
  if (ms < 60000) return null
  const m = Math.round(ms / 60000)
  return m >= 180 ? _format.pluralize.call(void 0, Math.round(m / 60), 'hour', 'hours') : _format.pluralize.call(void 0, m, 'minute', 'minutes')
}; exports.durationText = durationText

/* "about 5 minutes" / "under a minute" */
 const sendDuration = (count, delayMs) => {
  const text = exports.durationText.call(void 0, count, delayMs)
  return text ? `about ${text}` : 'under a minute'
}; exports.sendDuration = sendDuration

/* "About 6 messages a minute. 300 recipients take about 50 minutes." (or
 * "300 messages", for the Send dialog's count) */
 const paceHint = (ms, count, unit = 'recipient') => {
  const rate = `About ${Math.round(60000 / Math.max(ms, _broadcastCampaign.MIN_MESSAGE_DELAY_MS))} messages a minute.`
  if (!count) return rate
  const who = _format.pluralize.call(void 0, count, `${unit} takes`, `${unit}s take`)
  return `${rate} ${who} ${exports.sendDuration.call(void 0, count, ms)}.`
}; exports.paceHint = paceHint
